module.exports = {"431281101":"黔城镇","431281102":"安江镇","431281103":"托口镇","431281104":"雪峰镇","431281106":"江市镇","431281107":"沅河镇","431281108":"塘湾镇","431281202":"岔头乡","431281203":"茅渡乡","431281204":"大崇乡","431281205":"熟坪乡","431281206":"铁山乡","431281207":"群峰乡","431281208":"湾溪乡","431281209":"洗马乡","431281211":"沙湾乡","431281212":"深渡苗族乡","431281213":"龙船塘瑶族乡","431281214":"太平乡","431281217":"岩垅乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431281.json
// module id = 1760
// module chunks = 0